export default __webpack_public_path__ + "static/media/gear.9f8c55bc.svg";